'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    DateiuploadResource = _require2.DateiuploadResource;

module.exports.Dateiupload = function (_BaseEntity) {
  _inherits(Dateiupload, _BaseEntity);

  _createClass(Dateiupload, null, [{
    key: '__name__',
    value: function __name__() {
      return 'dateiupload';
    }
  }]);

  function Dateiupload(data) {
    _classCallCheck(this, Dateiupload);

    var _this = _possibleConstructorReturn(this, (Dateiupload.__proto__ || Object.getPrototypeOf(Dateiupload)).call(this));

    _this.dateiFileName = null;
    _this.dateiMimeType = null;
    _this.dateiSize = null;
    _this.dateiUpdateFlag = null;

    _this.datei = null;
    _this.dateiUpload = null;
    _get(Dateiupload.prototype.__proto__ || Object.getPrototypeOf(Dateiupload.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(Dateiupload, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'dateiFileName', 'dateiMimeType', 'dateiSize', 'dateiUpdateFlag'],
        links: ['datei', 'dateiUpload']
      });
    }
  }, {
    key: 'fetchDatei',
    value: function fetchDatei() {
      return _get(Dateiupload.prototype.__proto__ || Object.getPrototypeOf(Dateiupload.prototype), 'genericResolve', this).call(this, 'datei');
    }
  }, {
    key: 'fetchDateiUpload',
    value: function fetchDateiUpload() {
      return _get(Dateiupload.prototype.__proto__ || Object.getPrototypeOf(Dateiupload.prototype), 'genericResolve', this).call(this, 'dateiUpload');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Dateiupload.prototype.__proto__ || Object.getPrototypeOf(Dateiupload.prototype), 'genericResolve', this).call(this, 'datei'), _get(Dateiupload.prototype.__proto__ || Object.getPrototypeOf(Dateiupload.prototype), 'genericResolve', this).call(this, 'dateiUpload')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof DateiuploadResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Dateiupload.prototype.__proto__ || Object.getPrototypeOf(Dateiupload.prototype), 'fetchQuery', this).call(this, DateiuploadResource);
      }
    }
  }]);

  return Dateiupload;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/dateiupload.js
// module id = mcL7
// module chunks = 0